import EquipmentNameAndType from './EquipmentNameAndType';

export default EquipmentNameAndType;
